'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { Link } from '@algoacademy/design-system/web/actions/Link';
import { showErrorToast } from '@algoacademy/design-system/web/feedback/Toaster/ToasterError';
import { Checkbox, CheckboxField } from '@algoacademy/design-system/web/forms/Checkbox';
import { ErrorMessage, Field, Label } from '@algoacademy/design-system/web/forms/Fieldset';
import { Input } from '@algoacademy/design-system/web/forms/Input';
import { Label2 } from '@algoacademy/design-system/web/typography/Label';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/solid';
import { zodResolver } from '@hookform/resolvers/zod';
import { useSearchParams } from 'next/navigation';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { authClient } from '@/app/_auth/auth-client';
import { resolveRedirect } from '@/app/auth/_helpers/resolve-redirect';
import { type RegisterFormSchema, RegisterFormSchemaZ } from './schema';
export function RegisterForm() {
  const $ = _c(82);
  const searchParams = useSearchParams();
  const redirect = resolveRedirect(searchParams.get("redirectTo") ?? searchParams.get("callbackUrl"));
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = zodResolver(RegisterFormSchemaZ);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      resolver: t0,
      mode: "onSubmit",
      defaultValues: {
        acceptTerms: false
      }
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    handleSubmit,
    control,
    register,
    formState: t2
  } = useForm(t1);
  const {
    errors
  } = t2;
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const onSubmit = async data => {
    setIsLoading(true);
    const {
      error: signUpError
    } = await authClient.signUp.email({
      email: data.email,
      password: data.password,
      name: data.username
    });
    if (signUpError) {
      showErrorToast(signUpError.message ?? "Wyst\u0105pi\u0142 b\u0142\u0105d podczas rejestracji");
      setIsLoading(false);
      return;
    }
    window.location.assign(redirect.url);
  };
  const t3 = handleSubmit(onSubmit);
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Label>Adres email</Label>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== register) {
    t5 = register("email");
    $[3] = register;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t5) {
    t6 = <Input type="email" placeholder="adres@email.pl" {...t5} />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== errors.email) {
    t7 = errors.email && <ErrorMessage>{errors.email.message}</ErrorMessage>;
    $[7] = errors.email;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = <Field>{t4}{t6}{t7}</Field>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Label>Nazwa użytkownika</Label>;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== register) {
    t10 = register("username");
    $[13] = register;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10) {
    t11 = <Input type="text" placeholder={"Nazwa u\u017Cytkownika"} {...t10} />;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== errors.username) {
    t12 = errors.username && <ErrorMessage>{errors.username.message}</ErrorMessage>;
    $[17] = errors.username;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t11 || $[20] !== t12) {
    t13 = <Field>{t9}{t11}{t12}</Field>;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Label>Hasło</Label>;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  const t15 = showPassword ? "text" : "password";
  let t16;
  if ($[23] !== register) {
    t16 = register("password");
    $[23] = register;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t15 || $[26] !== t16) {
    t17 = <Input type={t15} placeholder={"Minimum 8 znak\xF3w"} {...t16} />;
    $[25] = t15;
    $[26] = t16;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== setShowPassword) {
    t18 = () => setShowPassword(_temp);
    $[28] = setShowPassword;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== showPassword) {
    t19 = showPassword ? <EyeIcon className="h-4 w-4" /> : <EyeSlashIcon className="h-4 w-4" />;
    $[30] = showPassword;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== t18 || $[33] !== t19) {
    t20 = <button type="button" onClick={t18} className="absolute top-1/2 right-2 -translate-y-1/2 text-contentTertiary">{t19}</button>;
    $[32] = t18;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t17 || $[36] !== t20) {
    t21 = <div className="relative">{t17}{t20}</div>;
    $[35] = t17;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== errors.password) {
    t22 = errors.password && <ErrorMessage>{errors.password.message}</ErrorMessage>;
    $[38] = errors.password;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== t21 || $[41] !== t22) {
    t23 = <Field className="flex flex-col gap-2">{t14}{t21}{t22}</Field>;
    $[40] = t21;
    $[41] = t22;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <Label>Powtórz hasło</Label>;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  const t25 = showPassword ? "text" : "password";
  let t26;
  if ($[44] !== register) {
    t26 = register("confirmPassword");
    $[44] = register;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  let t27;
  if ($[46] !== t25 || $[47] !== t26) {
    t27 = <Input type={t25} placeholder={"Powt\xF3rz has\u0142o"} {...t26} />;
    $[46] = t25;
    $[47] = t26;
    $[48] = t27;
  } else {
    t27 = $[48];
  }
  let t28;
  if ($[49] !== setShowPassword) {
    t28 = () => setShowPassword(_temp2);
    $[49] = setShowPassword;
    $[50] = t28;
  } else {
    t28 = $[50];
  }
  let t29;
  if ($[51] !== showPassword) {
    t29 = showPassword ? <EyeIcon className="h-4 w-4" /> : <EyeSlashIcon className="h-4 w-4" />;
    $[51] = showPassword;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  let t30;
  if ($[53] !== t28 || $[54] !== t29) {
    t30 = <button type="button" onClick={t28} className="absolute top-1/2 right-2 -translate-y-1/2 text-contentTertiary">{t29}</button>;
    $[53] = t28;
    $[54] = t29;
    $[55] = t30;
  } else {
    t30 = $[55];
  }
  let t31;
  if ($[56] !== t27 || $[57] !== t30) {
    t31 = <div className="relative">{t27}{t30}</div>;
    $[56] = t27;
    $[57] = t30;
    $[58] = t31;
  } else {
    t31 = $[58];
  }
  let t32;
  if ($[59] !== errors.confirmPassword) {
    t32 = errors.confirmPassword && <ErrorMessage>{errors.confirmPassword.message}</ErrorMessage>;
    $[59] = errors.confirmPassword;
    $[60] = t32;
  } else {
    t32 = $[60];
  }
  let t33;
  if ($[61] !== t31 || $[62] !== t32) {
    t33 = <Field className="flex flex-col gap-2">{t24}{t31}{t32}</Field>;
    $[61] = t31;
    $[62] = t32;
    $[63] = t33;
  } else {
    t33 = $[63];
  }
  let t34;
  if ($[64] !== control) {
    t34 = <div className="flex items-center"><Controller name="acceptTerms" control={control} render={_temp3} /></div>;
    $[64] = control;
    $[65] = t34;
  } else {
    t34 = $[65];
  }
  let t35;
  if ($[66] !== errors.acceptTerms) {
    t35 = errors.acceptTerms && <ErrorMessage>{errors.acceptTerms.message}</ErrorMessage>;
    $[66] = errors.acceptTerms;
    $[67] = t35;
  } else {
    t35 = $[67];
  }
  let t36;
  if ($[68] !== t34 || $[69] !== t35) {
    t36 = <Field>{t34}{t35}</Field>;
    $[68] = t34;
    $[69] = t35;
    $[70] = t36;
  } else {
    t36 = $[70];
  }
  const t37 = isLoading ? "Rejestracja..." : "Zarejestruj si\u0119";
  let t38;
  if ($[71] !== isLoading || $[72] !== t37) {
    t38 = <Button type="submit" color="algoprimary" className="w-full" disabled={isLoading}>{t37}</Button>;
    $[71] = isLoading;
    $[72] = t37;
    $[73] = t38;
  } else {
    t38 = $[73];
  }
  let t39;
  if ($[74] !== t13 || $[75] !== t23 || $[76] !== t3 || $[77] !== t33 || $[78] !== t36 || $[79] !== t38 || $[80] !== t8) {
    t39 = <form onSubmit={t3} className="space-y-4">{t8}{t13}{t23}{t33}{t36}{t38}</form>;
    $[74] = t13;
    $[75] = t23;
    $[76] = t3;
    $[77] = t33;
    $[78] = t36;
    $[79] = t38;
    $[80] = t8;
    $[81] = t39;
  } else {
    t39 = $[81];
  }
  return t39;
}
function _temp3(t0) {
  const {
    field: t1
  } = t0;
  const {
    value,
    onChange
  } = t1;
  return <CheckboxField><Checkbox checked={value} onChange={onChange} /><Label><Label2>Akceptuję{" "}<Link href="/regulamin" className="text-contentNavyAlgo hover:underline">regulamin AlgoAcademy</Link><span className="text-contentRed">*</span></Label2></Label></CheckboxField>;
}
function _temp2(prev_0) {
  return !prev_0;
}
function _temp(prev) {
  return !prev;
}